// 封装的目的是封装公共的拦截器 ， 每个实例有单独自己拦截器

import { MessagePlugin, LoadingPlugin, DialogPlugin } from 'tdesign-vue';
import router from '@/router';
import {
  generateRandomString,
  urlAppendParams,
  cleanObj,
} from '@/utils/utils';
import { encryptData } from '@/utils/crypto';
import { loginLocationWithInvite } from '@/utils/inviteSession';
let loadingInstance = null;
const { GY } = window;

class Http {
  constructor() {
    this.timeout = 8000;
    this.baseURL = '';
  }
  async mergeOptions(options) {
    if (options.encrypt) {
      const gy_nonce = generateRandomString();
      const gy_timestamp = Date.now();
      const { encrypted: gy_signature_token, key: gy_key } = await encryptData(
        options.data,
        gy_nonce,
        gy_timestamp,
      );
      options.data = {
        ...options.data,
        gy_nonce,
        gy_timestamp,
        gy_signature_token,
        gy_key,
      };
    }
    // 合并参数
    return new Promise(resolve => {
      options.data = {
        ...cleanObj(options.data),
      };
      resolve({
        timeout: this.timeout,
        ...options,
      });
    });
    // return {
    //   timeout: this.timeout,
    //   ...options,
    // };
  }
  setInterceptor(instance, options) {
    return new Promise((resolve, reject) => {
      if (!loadingInstance) {
        loadingInstance =
          options.options.url.indexOf('GetMessageCenter') ||
          options.options.url.indexOf('GetSystemMessage') !== -1
            ? ''
            : LoadingPlugin(true);
      }
      instance
        .then(
          res => {
            if (Number(res.code) === 0) {
              resolve(res.data || res);
            } else if (Number(res.code) === 110027 || Number(res.code) ===  31600007) {
              // 登录态失效。登录/邀请页不要 GYLogout：sign_out 异步返回会清掉刚扫码拿到的 session
              const onLoginPage = router.currentRoute && router.currentRoute.path === '/login';
              if (options.options.skipAuthRedirect || onLoginPage) {
                reject(res);
                return;
              }
              const goLogin = () => {
                sessionStorage.removeItem('nolocate');
                const query = (router.currentRoute && router.currentRoute.query) || {};
                router.push(loginLocationWithInvite(query));
              };
              const logout = window.GYL && window.GYL.GYLogout;
              if (typeof logout === 'function') {
                logout().then(goLogin).catch(goLogin);
              } else {
                goLogin();
              }
            } else if (Number(res.code) === 32240002 ) {
              // 登录态有效，但是没有绑定企业 id, 跳转到登录页重新select_org
              // skipNoEntRedirect: 仅放行本场景（如企业入驻页，未选企业是入驻前的合法状态），
              // 登录态失效（110027）仍由上面的分支送回登录页
              if (options.options.skipAuthRedirect || options.options.skipNoEntRedirect) {
                reject(res);
                return;
              }
              const query = (router.currentRoute && router.currentRoute.query) || {};
              router.push(loginLocationWithInvite(query));
            } else if (Number(res.code) === 32240035) {
              // 入驻流程没有走完，要跳到对应的步骤
              if (options.options.skipAuthRedirect) {
                reject(res);
                return;
              }
              sessionStorage.removeItem('nolocate')
              router.push('/register');
            } else {
              const msg = res.msg || res.message || res.reason || '';
              if (msg.includes('以下字段被驳回，需要修改后才能提交')) {
                const alertDia = DialogPlugin.alert({
                  body: res.msg || res.message || res.reason,
                  header: '提示', // 头部内容
                  width: '700px', // 对话框宽度
                  placement: 'center',
                  cancelBtn: null, // 是否显示取消按钮
                  confirmBtn: null, // 自定义按钮名称
                  onClose: () => {
                    alertDia.hide();
                  },
                });
              } else if (
                options.options?.hideErrorCodes?.includes(Number(res.code))
              ) {
                // ?
              } else if (!options.options.hideErrorMessage) {
                MessagePlugin.error(
                  res.msg || res.message || res.reason || '失败',
                );
              }
              reject(res);
            }
          },
          err => {
            if (
              (err.errDetail || err.errMsg) &&
              !options.options.hideErrorMessage
            ) {
              // 弹框处理错误逻辑'
              MessagePlugin.error('请求失败');
            }
            reject(err instanceof Error ? err : new Error(JSON.stringify(err)));
          },
        )
        .finally(() => {
          // 关闭逻辑
          if (loadingInstance) {
            LoadingPlugin(false);
            loadingInstance = null;
          }
        });
    });
  }
  async request(options) {
    // const opts = this.mergeOptions(options);
    const res = this.mergeOptions(options).then(res => {
      const opts = res;
      const reg2 = /([^/]+)$/;
      // 获取最后一个/后面的所有字符
      const bluefile = opts.url.match(reg2)[1];
      // // 首字母转大写或小写
      const blu = this.firstToUpper(bluefile);

      // 正则替换
      if (opts.url.indexOf('http') === -1) {
        opts.url = opts.url.replace(bluefile, blu);
      }

      if (!opts.url.startsWith('https://')) {
        opts.url = this.switchingGateways(opts.url);
      }
      opts.headers = this.setHeader(opts.headers);
      opts.withCredentials = true;
      return this.setInterceptor(GY.Util.request.load(opts), {
        hideLoading: options.hideLoading,
        lastUrl: bluefile,
        options,
      });
    });
    return res;
  }

  switchingGateways(url, serve) {
    const hostname = location.hostname;
    const apihostname = hostname.replace(
      'corp.gongyi.qq.com',
      'api.gongyi.qq.com',
    );
    if (serve) {
      const baseURL = `https://${apihostname}/api${serve}`;
      const lastIndex = url.lastIndexOf('/');
      return urlAppendParams(baseURL + url.slice(lastIndex + 1), {
        urlhash: encodeURIComponent(location.hash.replace('#/', '')),
      });
    }
    return urlAppendParams(
      `https://${apihostname}${url.startsWith('/') ? '/api' : '/api/'}${url}`,
      {
        urlhash: encodeURIComponent(location.hash.replace('#/', '')),
      },
    ).replace('/api/api/', '/api/');
  }

  // // 首字母转大写其余保留
  firstToUpper(str) {
    return str.replace(/( |^)[a-z]/g, L => L.toUpperCase());
  }

  // // 首字母转小写其余保留
  firstLower(str) {
    return str.replace(/^./, L => L.toLowerCase());
  }
  setHeader(curHeaders) {
    if (!curHeaders) return this.headers;
    const h = curHeaders;
    const keys = Object.keys(this.headers);
    keys.forEach(key => (h[key] = this.header[key]));
    return h;
  }

  get(url, data, options = {}) {
    // params
    return this.request({
      url,
      method: 'post',
      data,
      ...options,
    });
  }
  post(url, data, options = {}, result) {
    // data
    // 对data进行格式化
    return this.request({
      method: 'post',
      url,
      data,
      ...options,
      result,
    });
  }
}

export default new Http();
